import { Drawer } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import AgencyIcon from "../../../components/icons/AgencyIcon";
import CloseIcon from "../../../components/icons/CloseIcon";
import DashboardIcon from "../../../components/icons/DashboardIcon";
import DesignTemplatesIcon from "../../../components/icons/DesignTemplatesIcon";
import DownArrowIcon from "../../../components/icons/DownArrowIcon";
import EmployeesIcon from "../../../components/icons/EmployeesIcon";
import MainLogo from "../../../components/icons/MainLogo";
import MyPropertiesIcon from "../../../components/icons/MyPropertiesIcon";
import ReferralIcon from "../../../components/icons/ReferralIcon";
import RoyaltyProgramIcon from "../../../components/icons/RoyaltyProgramIcon";
import SubscriptionsIcon from "../../../components/icons/SubscriptionsIcon";
import WorkspaceIcon from "../../../components/icons/WorkspaceIcon";
import { dashboardAction } from "../../../redux/features/dashboardSlice";
import { RootState } from "../../../redux/store";
import { clientRoutes } from "../../../utils/routes";
import "./SideDrawer.scss";
import { LocalStorageHelpers } from "../../../utils/helpers/localstorage.helpers";

const SideDrawer = () => {
  const dispatch = useDispatch();
  let sideBar = useSelector((state: RootState) => state?.dashboard?.sideBar);
  const location = useLocation();
  const [subMenuId, setSubMenuId] = useState("");

  const isDesigner = LocalStorageHelpers.isDesigner();

  const filteredSideBarItems = useMemo(() => {
    if (isDesigner) {
      return side_bar_item
        .filter((item) => item.itemName === "Work Setting")
        .map((item) => ({
          ...item,
          subMenu: item.subMenu.filter(
            (sub) =>
              // sub.itemName === "Design Templates" ||
              // sub.id === "work_setting_3",
              sub.itemName === "Master designs" || sub.id === "work_setting_3",
          ),
        }));
    }
    return side_bar_item;
  }, [isDesigner]);

  useEffect(() => {
    const currentPath = `/${location?.pathname?.split("/")[1] || ""}`;

    const activeParent = filteredSideBarItems.find((item) =>
      item?.subMenu?.some((sub: any) => sub?.link === currentPath),
    );

    if (activeParent?.id) {
      setSubMenuId(activeParent.id);
    }
  }, [location.pathname, filteredSideBarItems]);

  const onClose = () => {
    dispatch(dashboardAction?.setsideBar());
  };

  const onClickSubmenu = (id: string, e?: React.MouseEvent) => {
    e?.stopPropagation?.();
    setSubMenuId((prev) => (prev === id ? "" : id));
  };

  const checkActive = (subMenu: any[]) => {
    const currentPath = `/${location?.pathname?.split("/")[1] || ""}`;
    return subMenu?.some((subMenuData) => subMenuData?.link === currentPath);
  };

  return (
    <div className="side-drawer-container">
      <div className="web-drawer-container">
        <div className="side-bar-logo">
          {/* <img src="/images/logo.svg" alt="" /> */}
          <Link to="/">
            <MainLogo />
          </Link>
        </div>
        <div className="side-bar-list_item_container">
          {filteredSideBarItems?.map((data) => {
            if (data?.subMenu?.length === 0) {
              return (
                <Link key={data?.id} to={data?.link} onClick={onClose}>
                  <div
                    className={`item margin-top-side-bar ${
                      `/${location?.pathname?.split("/")[1]}` == data?.link
                        ? "active-link"
                        : ""
                    }`}
                    key={data?.id}
                  >
                    <div className="item_icon">{data?.itemIcon}</div>
                    <div className="item_name">
                      <p> {data?.itemName}</p>
                    </div>
                  </div>
                </Link>
              );
            } else {
              const isOpen = data?.id === subMenuId;
              const isParentActive = checkActive(data?.subMenu);

              return (
                <div key={data?.id}>
                  <div
                    className={`manu-and-icon-contain ${
                      isParentActive ? "active-link" : ""
                    }`}
                    onClick={(e) => onClickSubmenu(data?.id, e)}
                  >
                    <div className="item" key={data?.id}>
                      <div className="item_icon">{data?.itemIcon}</div>
                      <div className="item_name">
                        <p> {data?.itemName}</p>
                      </div>
                    </div>
                    <div
                      className={`side-bar-down-icon ${
                        isOpen ? "active-down-icon" : ""
                      }`}
                    >
                      <DownArrowIcon />
                    </div>
                  </div>

                  <div
                    className={`sub-menu-contain-container ${
                      isOpen ? "" : "display_none"
                    }`}
                  >
                    {data?.subMenu?.map((subData: any) => (
                      <Link
                        key={subData?.id}
                        to={subData?.link}
                        onClick={(e) => {
                          e.stopPropagation();
                          onClose();
                        }}
                      >
                        <div
                          className={`sub-item ${
                            `/${location?.pathname?.split("/")[1]}` ==
                            subData?.link
                              ? "active-link"
                              : ""
                          }`}
                          key={subData?.id}
                        >
                          <div className="sub-item_icon">
                            {subData?.itemIcon}
                          </div>
                          <div className="sub-item_name">
                            <p> {subData?.itemName}</p>
                          </div>
                        </div>
                      </Link>
                    ))}
                  </div>
                </div>
              );
            }
          })}
        </div>
      </div>

      <div className="mobile-drawer-container">
        <Drawer
          className="sidebar-drawer"
          classes={{
            paper: "sidebar-drawer-paper",
          }}
          open={sideBar}
          onClose={onClose}
        >
          <div className="mobile_top_contain">
            <div className="mobile-side-bar-logo">
              {/* <img src="./images/logo.svg" alt="" /> */}
              <MainLogo />
            </div>
            <div className="mobile-close-logo" onClick={onClose}>
              <CloseIcon />
            </div>
          </div>
          <div className="side-bar-list_item_container">
            {filteredSideBarItems?.map((data) => {
              if (data?.subMenu?.length === 0) {
                return (
                  <Link key={data?.id} to={data?.link}>
                    <div
                      className={`item margin-top-side-bar ${
                        `/${location?.pathname?.split("/")[1]}` == data?.link
                          ? "active-link"
                          : ""
                      }`}
                      key={data?.id}
                    >
                      <div className="item_icon">{data?.itemIcon}</div>
                      <div className="item_name">
                        <p> {data?.itemName}</p>
                      </div>
                    </div>
                  </Link>
                );
              } else {
                return (
                  <div key={data?.id} onClick={() => onClickSubmenu(data?.id)}>
                    <div
                      className={`manu-and-icon-contain ${
                        checkActive(data?.subMenu) ? "active-link" : ""
                      }`}
                    >
                      <div className={`item`} key={data?.id}>
                        <div className="item_icon">{data?.itemIcon}</div>
                        <div className="item_name">
                          <p> {data?.itemName}</p>
                        </div>
                      </div>
                      <div
                        className={`side-bar-down-icon  ${
                          data?.id === subMenuId ? "active-down-icon " : ""
                        }`}
                      >
                        <DownArrowIcon />
                      </div>
                    </div>

                    <div
                      className={`sub-menu-contain-container ${
                        data?.id === subMenuId ? "" : "display_none"
                      }`}
                    >
                      {data?.subMenu?.map((subData: any) => (
                        <Link
                          key={subData?.id}
                          to={subData?.link}
                          onClick={onClose}
                        >
                          <div
                            className={`sub-item ${
                              `/${location?.pathname?.split("/")[1]}` ==
                              subData?.link
                                ? "active-link"
                                : ""
                            }`}
                            key={subData?.id}
                          >
                            <div className="sub-item_icon">
                              {subData?.itemIcon}
                            </div>
                            <div className="sub-item_name">
                              <p> {subData?.itemName}</p>
                            </div>
                          </div>
                        </Link>
                      ))}
                    </div>
                  </div>
                );
              }
            })}
          </div>
        </Drawer>
      </div>
    </div>
  );
};

export default SideDrawer;

const side_bar_item = [
  {
    itemName: "Dashboard",
    itemIcon: <DashboardIcon />,
    id: "1",
    link: clientRoutes.home,
    subMenu: [],
  },
  {
    itemName: "Users",
    itemIcon: <EmployeesIcon />,
    id: "2",
    link: clientRoutes.users,
    subMenu: [],
  },
  {
    itemName: "Brands",
    itemIcon: <DesignTemplatesIcon />,
    id: "3",
    link: "",
    subMenu: [
      {
        itemName: "Agencies",
        itemIcon: <AgencyIcon />,
        id: "brands_1",
        link: clientRoutes.agencies,
      },
      {
        itemName: "Agents",
        itemIcon: <EmployeesIcon />,
        id: "brands_2",
        link: clientRoutes.agents,
      },
      {
        itemName: "Properties",
        itemIcon: <MyPropertiesIcon />,
        id: "brands_3",
        link: clientRoutes.properties,
      },
      {
        itemName: "Brands",
        itemIcon: <MyPropertiesIcon />,
        id: "brands_4",
        link: clientRoutes?.BrandList,
      },
    ],
  },
  {
    itemName: "Work Setting",
    itemIcon: <DesignTemplatesIcon />,
    id: "4",
    link: "",
    subMenu: [
      // {
      //   itemName: "Template Type",
      //   itemIcon: <DesignTemplatesIcon />,
      //   id: "work_setting_1",
      //   link: clientRoutes.designTemplateTypes,
      // },
      {
        itemName: "Subscriptions",
        itemIcon: <SubscriptionsIcon />,
        id: "work_setting_2",
        link: clientRoutes?.subscriptions,
      },
      // {
      //   itemName: "Design Templates",
      //   itemIcon: <DesignTemplatesIcon />,
      //   id: "work_setting_3",
      //   link: clientRoutes?.designTemplates,
      // },
      {
        itemName: "Master designs",
        itemIcon: <DesignTemplatesIcon />,
        id: "work_setting_3",
        link: clientRoutes?.designTemplates,
      },
      {
        itemName: "Property Stages",
        itemIcon: <DesignTemplatesIcon />,
        id: "work_setting_4",
        link: clientRoutes?.propertyStages,
      },
      {
        itemName: "Wallet Points",
        itemIcon: <DesignTemplatesIcon />,
        id: "work_setting_5",
        link: clientRoutes?.manualWalletPoints,
      },
    ],
  },
  {
    itemName: "Program",
    itemIcon: <DesignTemplatesIcon />,
    id: "5",
    link: "",
    subMenu: [
      {
        itemName: "Referrals",
        itemIcon: <ReferralIcon />,
        id: "program_1",
        link: clientRoutes?.referrals,
      },
      {
        itemName: "Royalty Program",
        itemIcon: <RoyaltyProgramIcon />,
        id: "program_2",
        link: clientRoutes?.royaltyProgram,
      },
    ],
  },
  {
    itemName: "Workspace",
    itemIcon: <WorkspaceIcon />,
    id: "6",
    link: clientRoutes?.workspace,
    subMenu: [],
  },
  {
    itemName: "Invitations",
    itemIcon: <ReferralIcon />,
    id: "7",
    link: clientRoutes?.manageInvites,
    subMenu: [],
  },
  {
    itemName: "Property Bank",
    itemIcon: <MyPropertiesIcon />,
    id: "8",
    link: clientRoutes?.propertyBank,
    subMenu: [],
  },
  //     {
  //   itemName: "Brands",
  //   itemIcon: <MyPropertiesIcon />,
  //   id: "9",
  //   link: clientRoutes?.BrandList,
  //   subMenu: [],
  // },
  {
    itemName: "Agency Fonts",
    itemIcon: <WorkspaceIcon />,
    id: "9",
    link: clientRoutes?.agencyFonts,
    subMenu: [],
  },
  {
    itemName: "Brand Fonts",
    itemIcon: <WorkspaceIcon />,
    id: "10",
    link: clientRoutes?.brandFonts,
    subMenu: [],
  },
  {
    itemName: "System Fonts",
    itemIcon: <WorkspaceIcon />,
    id: "11",
    link: clientRoutes?.systemFonts,
    subMenu: [],
  },
];
